// extracted by mini-css-extract-plugin
module.exports = {"textCell":"SummaryRow_textCell__IywHB","firstCell":"SummaryRow_firstCell__3l3qH"};